'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002422 from "./presto.-Dashboard-View$$anon$22.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dAccount$002dName$0024 from "./presto.types$-Account-Name$.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dAccount$002dStats$0024 from "./presto.types$-Dashboard-Account-Stats$.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardView$$anon$21() {
  this.aLf = null;
  this.aL7 = null;
  this.aL8 = false;
  this.aLg = null;
  this.aLh = false;
  this.aLk = null;
  this.aLd = null;
  this.aLe = false;
  this.aL9 = null;
  this.aLa = false;
  this.aLb = null;
  this.aLc = false;
  this.aLi = false;
  this.aLj = false;
  this.aLf = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aLk = "DashboardAccountStats";
}
export { $c_Lpresto_DashboardView$$anon$21 as $c_Lpresto_DashboardView$$anon$21 };
$p = $c_Lpresto_DashboardView$$anon$21.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardView$$anon$21;
/** @constructor */
function $h_Lpresto_DashboardView$$anon$21() {
}
export { $h_Lpresto_DashboardView$$anon$21 as $h_Lpresto_DashboardView$$anon$21 };
$h_Lpresto_DashboardView$$anon$21.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.aLf;
});
$p.M = (function() {
  if ((!this.aL8)) {
    this.aL7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aL8 = true;
  }
  return this.aL7;
});
$p.O = (function() {
  if ((!this.aLh)) {
    this.aLg = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aLh = true;
  }
  return this.aLg;
});
$p.D = (function() {
  return this.aLk;
});
$p.t = (function() {
  if ((!this.aLe)) {
    this.aLd = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("total", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aLe = true;
  }
  return this.aLd;
});
$p.N = (function() {
  if ((!this.aLa)) {
    this.aL9 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().bl(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dName$0024.$m_Lpresto_types$AccountName$().adY(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bC, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aLa = true;
  }
  return this.aL9;
});
$p.Q = (function() {
  if ((!this.aLc)) {
    this.aLb = new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002422.$c_Lpresto_DashboardView$$anon$22();
    this.aLc = true;
  }
  return this.aLb;
});
$p.v = (function() {
  if ((!this.aLj)) {
    this.aLi = false;
    this.aLj = true;
  }
  return this.aLi;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee111) => ((p) => \u03b4scrutinee111.cHn(p)))($j_presto$002etypes$0024$002dDashboard$002dAccount$002dStats$0024.$m_Lpresto_types$DashboardAccountStats$())));
});
var $d_Lpresto_DashboardView$$anon$21 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardView$$anon$21, "presto.DashboardView$$anon$21", ({
  GV: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_DashboardView$$anon$21 as $d_Lpresto_DashboardView$$anon$21 };
//# sourceMappingURL=presto.-Dashboard-View$$anon$21.js.map
